import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./TrackEditContributers.css";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import { Button, Select, MenuItem } from "@material-ui/core";
import clsx from "clsx";
// import { _mlPlaylists, _mlPlaylistsMetadataConfig } from "../../../_module/definition/MlPlaylists";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
import { TextInput } from "../../input-elements/TextInput";
import { BiTrash } from "react-icons/bi";
import ContributorTypes from "../../../_module/definition/ContributorTypes";
import { validateEditTrackContributors } from "../../validations/content-validations/UploadValidation";
import { setError, setContributors, showAutoMessage } from '../../../redux/actions/MLTrackUpdateAction'



class TrackEditContributers extends Component {
    constructor() {
        super();
        this.state = {
            previewArray: [],
            rolePreview: {},
            doUpdate: true
        };
    }


    componentDidMount() {
        this.state.rolePreview.role = "featured_artist";

        const {
            updateData: { contributorsEdit },
            updateData,
            setContributors
        } = this.props;

        if (!contributorsEdit && updateData?.trackEditing?.trackMetadata?.contributor) {
            setContributors(updateData?.trackEditing?.trackMetadata?.contributor)
        }
    }

    componentDidUpdate() {
        const {
            updateData: { contributorsEdit }
        } = this.props;
        if (this.state.doUpdate && contributorsEdit && contributorsEdit.length > 0) {
            this.setState({ previewArray: contributorsEdit, doUpdate: false })
        }
    }


    handleAdd = () => {
        var addRole = true;
        const { setError, setContributors, showAutoMessage } = this.props;

        //Set Errors 
        let errors = validateEditTrackContributors(JSON.parse(JSON.stringify(this.state.rolePreview)));
        if (errors) {
            setError(errors)
            return;
        }
        else {
            setError(null)
        }

        //Set Object
        if (this.state.previewArray.length <= 0) {
            this.state.previewArray.push(JSON.parse(JSON.stringify(this.state.rolePreview)))
            this.setState({ previewArray: this.state.previewArray })
            this.state.rolePreview.isni = "";
            this.state.rolePreview.name = "";
            this.setState({ rolePreview: this.state.rolePreview })
            setContributors(this.state.previewArray)
        }
        else {
            this.state.previewArray.forEach((item) => {
                if (item.role === this.state.rolePreview.role) {
                    showAutoMessage("This role has already being assigned!");
                    addRole = false;
                }
            });
            if (addRole) {
                this.state.previewArray.push(JSON.parse(JSON.stringify(this.state.rolePreview)))
                this.setState({ previewArray: this.state.previewArray })
                this.state.rolePreview.isni = "";
                this.state.rolePreview.name = "";
                this.setState({ rolePreview: this.state.rolePreview })
                setContributors(this.state.previewArray)
            }
        }
    }

    checkExistingRoleNames = () => {

    }

    handleRemove = (index) => {
        this.state.previewArray.splice(index, 1);
        this.setState({ previewArray: this.state.previewArray })
    }


    handleValChange = (event) => {
        const _name = event.target.name;
        const _val = event.target.value;

        if (_name == 'role') {
            this.state.rolePreview.role = _val;
        }
        else if (_name == 'isni') {
            this.state.rolePreview.isni = _val;
        }
        else if (_name == 'name') {
            this.state.rolePreview.name = _val;
        }

        this.setState({ rolePreview: JSON.parse(JSON.stringify(this.state.rolePreview)) })
    };

    mapRole(property) {
        var selectedProperty = "";
        if (property) {
            Object.keys(ContributorTypes).map((value) => {
                if (property == ContributorTypes[value].id) {
                    selectedProperty = ContributorTypes[value].name;
                }
            })
            return selectedProperty;
        }
    }


    render() {

        const {
            classes,
            updateData: { posting: { busy, message, errors }, contributorsEdit },
        } = this.props;

        const { previewArray, rolePreview } = this.state;

        return (

            <Translation>
                {(t, { i18n }) => (
                    <Paper className={clsx(classes.contributorContainer)}
                        role="contentinfo">
                        <div>
                            <div className={clsx(classes.tableFilterInput, classes.musicOrigin)}>
                                <div>
                                    <label
                                        className={classes.globalCreateLabel}>
                                        Role
                                    </label>
                                    <Select
                                        variant="outlined"
                                        name="role"
                                        inputProps={{
                                            'id': "Role",
                                            'aria-labelledby': "Role"
                                        }}
                                        defaultValue={"featured_artist"}
                                        value={rolePreview ? rolePreview?.role : "" || ""}
                                        onChange={(e) => this.handleValChange(e)}
                                    >
                                        {Object.keys(ContributorTypes).map((v, i) => (
                                            <MenuItem value={ContributorTypes[v].id}>
                                                {ContributorTypes[v].name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                            <div>
                                <label
                                    className={classes.globalCreateLabel}>
                                    Name
                                </label>
                                <TextInput
                                    name="name"
                                    type="text"
                                    classes={classes}
                                    inputProps={{
                                        'aria-label': "Name"
                                    }}
                                    handleChange={(e) => this.handleValChange(e)}
                                    value={rolePreview ? rolePreview?.name : "" || ""}
                                    errors={errors || {}}
                                />
                            </div>
                            {/* <div>
                                <label
                                    className={classes.globalCreateLabel}>
                                    ISNI
                                </label>
                                <TextInput
                                    name="isni"
                                    type="text"
                                    classes={classes}
                                    inputProps={{
                                        'aria-label': "ISNI"
                                    }}
                                    handleChange={(e) => this.handleValChange(e)}
                                    value={rolePreview ? rolePreview?.isni : "" || ""}
                                    errors={errors || {}}
                                />
                            </div> */}
                            <div className={classes.contributorSaveButton}>
                                <div>
                                    {/* <Button
                                    className={classes.globalGrayButton}
                                    onClick={this.handleVisible}
                                >
                                    Cancel
                                </Button> */}
                                    <Button
                                        className={classes.globalGreenButton}
                                        onClick={() => this.handleAdd()}
                                    >
                                        Add
                                    </Button>
                                </div>
                            </div>

                            {contributorsEdit && contributorsEdit.length > 0 && contributorsEdit.map((card, index) => (
                                <>
                                    {this.mapRole(card.role) ? <div class="contributorItems">

                                        <div className={clsx(classes.tableFilterInput, classes.contributorItems)}>
                                            <div>
                                                <div  title={this.mapRole(card.role)}><span>Role </span>: {this.mapRole(card.role)}</div>
                                                <div><span>Name </span>: {card.name}</div>
                                                {/* <div><span>ISNI </span>: {card.isni}</div> */}
                                            </div>
                                            <Button
                                                className={classes.contributorItemRemove}
                                                disabled={busy ? true : false}
                                                onClick={() => this.handleRemove(index)}
                                            >
                                                <BiTrash />

                                            </Button>

                                        </div>
                                    </div> : null}

                                </>
                            ))}
                        </div>
                    </Paper>
                )}
            </Translation>
        );
    }
}

const mapStateToProps = (state) => ({
    updateData: state.mlTrackUpdateReducer,


});

export default connect(mapStateToProps, {
    setError,
    setContributors,
    showAutoMessage
}
)(withStyles(styles)(TrackEditContributers));
